export default "__VITE_ASSET__b08d4f86__"